import { DashboardLayout } from "layouts/dashboard.layout";
import { AppSalesTable } from "./components/sales-table.component";
import { salesPageData } from "constants/sales-page.data";
import { Paginated } from "modules/dashboard/components/paginated.component";
import VuiButton from "components/VuiButton";
import SystemUpdateAltOutlinedIcon from "@mui/icons-material/SystemUpdateAltOutlined";
import VuiBox from "components/VuiBox";
import { useEffect, useState } from "react";
import { getSalesIb } from "services/challenge-orders/challenge-orders.services";
import { unstable_batchedUpdates } from "react-dom";
import { getCountryById } from "utils/utils";

export function AppSalesPage() {
  const { salesTableColumns, codesButtonStates } = salesPageData;

  const [urlSearchParams, setUrlSearchParams] = useState("");
  const [salesRows, setSalesRows] = useState([]);
  const [itemsCounter, setItemsCounter] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(1);

  const formatDate = (date) => {
    if (date) {
      var objectDate = new Date(date);
      var year = objectDate.getFullYear();
      var month = objectDate.getMonth() + 1;
      var day = objectDate.getDate();
      return `${year}/${month}/${day}`;
    }
  };

  const downloadCSV = () => {
    const headers = salesTableColumns.map((column) => column.label.toUpperCase());
    const body = salesRows.map((row) => {
      return salesTableColumns
        .map((key) => {
          const value = row[key.property].default;
          return value ? JSON.stringify(value) : "";
        })
        .join(",");
    });
    const csv = [headers.join(","), ...body].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", "registers.csv");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  };

  const fetchSales = async ({ key, value, clear = false }) => {
    const newUrlSearchParams = new URLSearchParams(urlSearchParams);
    if (key && value !== "" && !clear) newUrlSearchParams.set(key, value);
    else newUrlSearchParams.delete(key);
    const filters = [...newUrlSearchParams.entries()].reduce((obj, [key, value]) => {
      obj[key] = obj[key]
        ? Array.isArray(obj[key])
          ? [...obj[key], value]
          : [obj[key], value]
        : value;
      return obj;
    }, {});
    const { success, data } = await getSalesIb({ filters });
    if (success) {
      const sales = data.items.map((item) => {
        const name = item.lastName && item.firstName && `${item.lastName} ${item.firstName}`;
        return {
          challengeOrderId: item.challengeOrderId,
          lastName: { default: name },
          paymentDate: { default: formatDate(item.paymentDate) },
          description: { default: item.description },
          email: { default: item.email },
          countryId: { default: getCountryById(item.countryId)?.country },
          balance: { default: item.balance },
          mt5AccountBalance: { default: item.mt5AccountBalance },
          partnerBenefitAmount: { default: item.partnerBenefitAmount },
          grade: item.grade,
          defaultValue: "- - - - - - - - -",
        };
      });
      unstable_batchedUpdates(() => {
        setSalesRows(sales);
        setUrlSearchParams(newUrlSearchParams);
        if (data.hasPaging) {
          setItemsCounter(data.itemsCounter);
          setCurrentPage(data.hasPaging);
          setPageSize(data.paginSize);
          if (data.hasPaging !== currentPage) {
            newUrlSearchParams.set("page", data.hasPaging);
          }
        }
      });
    }
  };

  useEffect(() => {
    fetchSales({ key: "page", value: 1 });
  }, []);

  return (
    <DashboardLayout>
      <VuiBox
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "0px 16px",
        }}
      >
        <VuiButton
          sx={({ breakpoints }) => ({
            width: "166px",
            fontSize: "12px",
            lineHeight: "18px",
            height: "28px",
            background: "transparent",
            color: "#fff",
            border: "solid 1px #fff",
            textTransform: "none",
            marginLeft: "auto",
            cursor: "pointer",
            [breakpoints.down("md")]: {
              display: "none",
            },
            "&:hover": { color: "unset" },
            "&:focus": { color: "unset" },
          })}
          onClick={downloadCSV}
        >
          <SystemUpdateAltOutlinedIcon
            sx={{
              marginRight: "5px",
            }}
          />
          <VuiBox
            sx={{
              color: "unset",
              fontSize: "12px",
            }}
          >
            DESCARGAR
          </VuiBox>
        </VuiButton>
      </VuiBox>
      <AppSalesTable
        salesTableRows={salesRows}
        salesTableColumns={salesTableColumns}
        codesButtonStates={codesButtonStates}
        fetchSales={fetchSales}
      />
      <Paginated
        itemsCounter={itemsCounter}
        pageSize={pageSize}
        currentPage={currentPage}
        changePage={(page) => {
          fetchSales({
            key: "page",
            value: page,
          });
        }}
        changeSize={(size) => {
          fetchSales({
            key: "size",
            value: size
          })
        }}
      />
    </DashboardLayout>
  );
}
